<template>
  <div id="vessel-edit-tab-general-info" v-if="localData">
<!--    <div>-->
<!--      <div class="vx-row">-->
<!--        <div class="vx-col md:w-1/4 w-full">-->
<!--          <div class="img-vessel">-->
<!--            <img :src="pictureUrl" />-->
<!--            <p>{{ pictureText }}</p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <!-- 一般情報 -->
    <div class="vx-row">
      <div class="vx-col md:w-1/3 w-full">
        <vs-input
          disabled
          class="w-full mt-4"
          label="船名"
          v-model="localData.name_ja"
          v-validate="'required'"
          name="name_ja"
          data-vv-as="船名"
        />
        <span class="text-danger text-sm" v-show="errors.has('name_ja')">{{
          errors.first("name_ja")
        }}</span>
      </div>
      <div class="vx-col md:w-1/3 w-full">
        <vs-input
          disabled
          class="w-full mt-4"
          label="船名(英名)"
          v-model="localData.name"
          v-validate="'required'"
          name="name"
          data-vv-as="船名(英名)"
        />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{
          errors.first("name")
        }}</span>
      </div>
      <div class="vx-col md:w-1/3 w-full mt-4">
        <label class="vs-input--label">船種</label>
        <v-select
          disabled
          placeholder="船種を選択してください"
          class="w-full v-select-license-add"
          label="name"
          :options="vesselCategoryOptions"
          v-model="selected"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        >
          <template v-slot:no-options>船種が見つかりません</template>
        </v-select>
      </div>
      <div class="vx-col md:w-1/6 w-full">
        <vs-input
          disabled
          class="w-full mt-4"
          label="長さ(m)"
          v-model="localData.vessel_size.length_overall"
          v-validate="'required'"
          name="name_ja"
          data-vv-as="長さ(m)"
        />
        <span class="text-danger text-sm" v-show="errors.has('name_ja')">{{
          errors.first("name_ja")
        }}</span>
      </div>
      <div class="vx-col md:w-1/6 w-full">
        <vs-input
          disabled
          class="w-full mt-4"
          label="幅(m)"
          v-model="localData.vessel_size.width"
          v-validate="'required'"
          name="width"
          data-vv-as="幅(m)"
        />
        <span class="text-danger text-sm" v-show="errors.has('width')">{{
          errors.first("width")
        }}</span>
      </div>
      <div class="vx-col md:w-1/6 w-full">
        <vs-input
          disabled
          class="w-full mt-4"
          label="喫水(m)"
          v-model="localData.vessel_size.full_draft"
          v-validate="'required'"
          name="full_draft"
          data-vv-as="喫水(m)"
        />
        <span class="text-danger text-sm" v-show="errors.has('full_draft')">{{
          errors.first("full_draft")
        }}</span>
      </div>
      <div class="vx-col md:w-1/6 w-full">
        <vs-input
          disabled
          class="w-full mt-4"
          label="総トン数(t)"
          v-model="localData.vessel_size.gt"
          v-validate="'required'"
          name="gt"
          data-vv-as="総トン数(t)"
        />
        <span class="text-danger text-sm" v-show="errors.has('gt')">{{
          errors.first("gt")
        }}</span>
      </div>
      <div class="vx-col md:w-1/6 w-full">
        <vs-input
          disabled
          class="w-full mt-4"
          label="船舶番号/漁船登録番号"
          v-model="localData.certificate_number"
          v-validate=""
          name="imo"
          data-vv-as="船舶番号/漁船登録番号"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('certificate_number')"
          >{{ errors.first("certificate_number") }}</span
        >
      </div>
      <div class="vx-col md:w-1/6 w-full">
        <vs-input
          disabled
          class="w-full mt-4"
          label="船体識別番号"
          v-model="localData.identification_number"
          v-validate="'required'"
          name="identification_number"
          data-vv-as="船体識別番号"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('identification_number')"
          >{{ errors.first("identification_number") }}</span
        >
      </div>
      <div class="vx-col md:w-1/6 w-full">
        <vs-input
          disabled
          class="w-full mt-4"
          label="IMO番号"
          v-model="localData.imo"
          v-validate="'required'"
          name="imo"
          data-vv-as="IMO番号"
        />
        <span class="text-danger text-sm" v-show="errors.has('imo')">{{
          errors.first("imo")
        }}</span>
      </div>
      <div class="vx-col md:w-1/6 w-full">
        <vs-input
          disabled
          class="w-full mt-4"
          label="MMSI"
          v-model="localData.mmsi"
          v-validate="'required'"
          name="mmsi"
          data-vv-as="MMSI"
        />
        <span class="text-danger text-sm" v-show="errors.has('mmsi')">{{
          errors.first("mmsi")
        }}</span>
      </div>
      <div class="vx-col md:w-1/6 w-full">
        <vs-input
          disabled
          class="w-full mt-4"
          label="Call Sign"
          v-model="localData.call_sign"
          v-validate="'required'"
          name="imo"
          data-vv-as="Call Sign"
        />
        <span class="text-danger text-sm" v-show="errors.has('call_sign')">{{
          errors.first("call_sign")
        }}</span>
      </div>
    </div>
    <div class="vx-row mt-12">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vx-tooltip text="船舶情報の編集は営業担当へお問い合わせください">
            <vs-button
              disabled
              icon-pack="feather"
              icon="icon-lock"
              id="button-with-loading"
              class="ml-auto mt-2"
              @click="saveChanges"
              >変更を保存する</vs-button
            >
          </vx-tooltip>
          <!--          <vs-button-->
          <!--            class="ml-4 mt-2"-->
          <!--            type="border"-->
          <!--            color="warning"-->
          <!--            @click="resetData"-->
          <!--            >リセット</vs-button-->
          <!--          >-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import vSelect from "vue-select";
import { storage } from "@/firebase/firebaseConfig";
import VesselMixin from "@/mixins/VesselMixin.js";
const { mapActions } = createNamespacedHelpers("enterpriseVesselEdit");

export default {
  components: {
    vSelect,
  },
  mixins: [VesselMixin],
  data() {
    return {
      pictureText: "",
      pictureUrl: require("@/assets/images/no_image_bg.svg"),
      hasPicture: false,
      localData: null,
      originData: null,
      options: this.vesselCategory,
      selected: null,
      activePrompt: false,
      photo: null
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    }
  },
  methods: {
    ...mapActions(["fetchVessel", "saveVessel"]),
    init() {
      this.createPhotoUrl();
    },
    createPhotoUrl() {
      if (this.localData.pictures.length !== 0) {
        this.pictureText = "取得中...";
        storage
          .child(this.localData.pictures[0].original_path)
          .getDownloadURL()
          .then(response => {
            this.pictureUrl = response;
            this.pictureText = "";
          });
      } else {
        this.pictureText = "No image";
      }
    },
    async saveChanges() {
      if (!this.validateForm) {
        return;
      }
      this.$vs.loading({
        type: "default",
        container: "#button-with-loading",
        scale: 0.45
      });
      try {
        let res = await this.saveVessel(
          JSON.parse(JSON.stringify(this.localData))
        );
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        this.$vs.notify({
          title: "基本情報を更新しました",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-right"
        });
        this.localData = res;
        this.originData = res;
      } catch (e) {
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        this.$vs.notify({
          title: "基本情報の更新に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center"
        });
      }
    },
    resetData() {
      this.localData = JSON.parse(JSON.stringify(this.originData));
    },
    showDialogUpload() {
      this.$refs.dialogUploadProfileImage.show();
    },
    imageUpdated(pictureData) {
      let request = JSON.parse(JSON.stringify(this.data));
      request.pictures[0] = pictureData.data;
      this.$store
        .dispatch("moduleUser/saveChanges", request)
        .then(() => {
          this.$vs.notify({
            title: "プロフィール画像を変更しました",
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
            position: "top-right"
          });
          this.photo = pictureData.url;
        })
        .catch(err => {
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          this.$vs.notify({
            title: "基本情報の更新に失敗しました",
            color: "danger",
            iconPack: "feather",
            icon: "icon-check",
            position: "top-center"
          });
          console.error(err);
        });
    }
  },
  async created() {
    let res = await this.fetchVessel(this.$route.params.vesselId);
    this.localData = res;
    this.originData = res;
    let index = Number(this.localData.vessel_category.id) - 1;
    this.selected = this.vesselCategoryOptions[index];
  }
};
</script>

<style lang="scss" scoped>
#vessel-edit-tab-general-info {
  .img-vessel {
    position: relative;
  }

  .img-vessel p {
    position: absolute;
    color: white;
    top: 50%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    margin: 0;
    padding: 0;
  }

  .img-vessel img {
    border-radius: 5px;
    width: 100%;
  }
}
.v-select-license-add {
  .vs__selected {
    padding: 0.24rem 0.24rem 0.24rem 0.62rem !important;
  }
  .vs__search {
    padding: 0.24rem 0.24rem 0.24rem 0.62rem !important;
  }
}

.vs__dropdown-toggle {
  border-radius: 5px;
}
</style>
